import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf48d856&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bf48d856&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf48d856",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/opt/buildhome/repo/components/global/Modal/index.vue').default,SimulatorType: require('/opt/buildhome/repo/components/simulator-flight/SimulatorType.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
